export default __webpack_public_path__ + "static/media/placeholder.2909a6ba.svg";